import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

export default class PageProjectsThumb extends Component {
	
	render () {
		
		let project = this.props.project;
						
		let thumbClass = 'c-property-thumbs__thumb'
		if (project.featured) {
			thumbClass = thumbClass + ' c-property-thumbs__thumb--featured';
		}
		
		return (

			<div className={thumbClass}>
			
				<Link to={project.url} className="c-property-thumbs__thumb__link">
					
					<div className="c-property-thumbs__thumb__image">
						
						{project.srcset && 
							<FadeIn>
								{onload => (
									<img
										alt={""} 
										src={project.src} 
										srcSet={project.srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						}
						{!project.srcset && 
							<FadeIn>
								{onload => (
									<img
										alt={""} 
										src={project.src} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						}
						
					</div>
					
					<div className="c-property-thumbs__thumb__text">
					
						<div className="c-property-thumbs__thumb__text__left">
							<h3 className="c-paragraph" dangerouslySetInnerHTML={{__html:project.heading}}></h3>
							<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:project.suburb}}></h4>
						</div>
						
						<div className="c-property-thumbs__thumb__text__right">
    						
    						{project.categories &&
    						
    							<p className="c-paragraph" dangerouslySetInnerHTML={{__html:project.categories}}></p>
    						
    						}
    						
    						{project.coordinates &&
	    						
    							<p className="c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{__html:project.coordinates}}></p>
    						
    						}
    						
    						{project.sold &&
								<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Sold'}}></p>
							}
							
							{project.under_offer &&
								<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Under Offer'}}></p>
							}
	
						</div>
						
					</div>
					
				</Link>
			
			</div>
		
		)
		
	}
}
